import { useEffect, useRef } from 'react';
import { trackShowcaseFirstEdit } from './showcaseAnalytics';

/**
 * Sends `showcase_first_edit` once, at the first change of the cut. `hasEdit` is true as soon as the
 * document has an Undo step (`canUndo` of the editor). An Undo back to the director's cut does not
 * send it again.
 */
export function useShowcaseFirstEdit(hasEdit: boolean): void {
  const isSent = useRef(false);
  useEffect(() => {
    if (!hasEdit || isSent.current) {
      return;
    }
    isSent.current = true;
    trackShowcaseFirstEdit();
  }, [hasEdit]);
}
